import { getI18n } from 'react-i18next';

interface ImporterBackend {
  hasImporter(namespace): boolean;
  addImporter(namespace, func): void;
}

/**
 * Adds a new importer to our lazy loading i18next backend.
 *
 * Note: This doesn't actually trigger the loading of translations: it defines a namespace and
 * how we import the translation resource. Said resource is only loaded after a `useTranslation(namespace)` call.
 *
 * @param namespace What namespace your translations should be stuck under. You'll reference this with `useTranslation(namespace)`
 * @param importer A callback that imports the desired translations.
 *
 * @example
 *    useLazyI18Next(
 *      'nc',
 *      (language, namespace, callback) => {
 *        import(`../assets/locale/messages_${language}.json`)
 *          .then(resources => callback(null, resources)
 *          .catch(error => callback(error, null)
 *      }
 *    )
 */
export default function useLazyI18next(namespace, importer) {
  const i18n = getI18n();
  const backend: ImporterBackend = i18n.modules.backend as any;

  if (
    backend &&
    backend.hasImporter &&
    typeof backend.hasImporter === 'function' &&
    !backend.hasImporter(namespace)
  ) {
    backend.addImporter(namespace, importer);
  }
}
